/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type OAuthProvider =
  | 'GOOGLE'
  | 'MICROSOFT';

export type StaffRole =
  | 'BRANCH_MANAGER'
  | 'CORPORATION_ADMIN'
  | 'ENTRANCE_MANAGER'
  | 'MEMBER';

export type FetchOnCalendarAuthViewQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchOnCalendarAuthViewQuery = { viewer: { is400FOA: boolean, staff: { role: Types.StaffRole, connectedThirdPartyProvider: Types.OAuthProvider | null } }, uiControl: { editOkanekoCalendarSetting: boolean } };


export const FetchOnCalendarAuthViewDocument = gql`
    query FetchOnCalendarAuthView {
  viewer {
    is400FOA
    staff {
      role
      connectedThirdPartyProvider
    }
  }
  uiControl {
    editOkanekoCalendarSetting
  }
}
    `;

/**
 * __useFetchOnCalendarAuthViewQuery__
 *
 * To run a query within a Vue component, call `useFetchOnCalendarAuthViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOnCalendarAuthViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchOnCalendarAuthViewQuery();
 */
export function useFetchOnCalendarAuthViewQuery(options: VueApolloComposable.UseQueryOptions<FetchOnCalendarAuthViewQuery, FetchOnCalendarAuthViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchOnCalendarAuthViewQuery, FetchOnCalendarAuthViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchOnCalendarAuthViewQuery, FetchOnCalendarAuthViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchOnCalendarAuthViewQuery, FetchOnCalendarAuthViewQueryVariables>(FetchOnCalendarAuthViewDocument, {}, options);
}
export function useFetchOnCalendarAuthViewLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchOnCalendarAuthViewQuery, FetchOnCalendarAuthViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchOnCalendarAuthViewQuery, FetchOnCalendarAuthViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchOnCalendarAuthViewQuery, FetchOnCalendarAuthViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchOnCalendarAuthViewQuery, FetchOnCalendarAuthViewQueryVariables>(FetchOnCalendarAuthViewDocument, {}, options);
}
export type FetchOnCalendarAuthViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchOnCalendarAuthViewQuery, FetchOnCalendarAuthViewQueryVariables>;